import React from "react";
import utils from "../../universal/utils";

export default function usePublicStats() {
  const [stats, setStats] = React.useState(null);
  const basePath = React.useMemo(() => utils.getEdgeBasePath(), []);

  React.useEffect(() => {
    let cancelled = false;
    fetch(`${basePath}/public/stats`, { credentials: "omit" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data) setStats(data);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [basePath]);

  return stats;
}
